enum ReportType {
  CSV = 'CSV',
  PDF = 'PDF',
}

export default ReportType;
